__webpack_require__.p = "/tour/_next/";